import React, { VFC, useContext, useRef, useEffect } from 'react';

import MarketplaceItemsContext from '@/contexts/MarketplaceItemsContext';
import TagRight from '@/icons/tag-right.svg';

import styles from './TagScroller.module.scss';
import TagSelector from './TagSelector';

const SCROLLDISTANCE = 700;
const SCROLLDURATION = 1000;
const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};

type Props = {
  isShowingNFTs: boolean;
};

const TagScroller: VFC<Props> = ({ isShowingNFTs }: Props) => {
  const searchCondition = isShowingNFTs
    ? useContext(MarketplaceItemsContext).searchConditionNFTs
    : useContext(MarketplaceItemsContext).searchConditionUsers;

  const scrollerRef = useRef(null);

  const scrollRight = (distance: number, duration: number) => {
    const start = scrollerRef.current.scrollLeft,
      increment = 20;
    let currentTime = 0;

    const animateScroll = () => {
      currentTime += increment;
      const val = easeInOutQuad(currentTime, start, distance, duration);
      scrollerRef.current.scrollLeft = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };

  return (
    <>
      {searchCondition.tagNames.length > 0 && (
        <div className={styles.tagScrollerWapper}>
          <TagRight
            className={styles.tagLeft}
            onClick={() => scrollRight(-SCROLLDISTANCE, SCROLLDURATION)}
          />
          <div className={styles.tagScroller} ref={scrollerRef}>
            {searchCondition.tagNames.map((tagName, index) => (
              <TagSelector
                key={tagName}
                tagName={searchCondition.tagNames[index]}
                tagNameJA={searchCondition.tagNamesJA[index]}
                isShowingNFTs={isShowingNFTs}
              />
            ))}
          </div>
          <TagRight
            className={styles.tagRight}
            onClick={() => scrollRight(SCROLLDISTANCE, SCROLLDURATION)}
          />
        </div>
      )}
    </>
  );
};
export default TagScroller;
